import React, { PropTypes } from 'react';
import SelectedLayer from './SelectedLayer';
import MapLayers from './MapLayers';

export default class Layers extends React.Component {
 
	maplayerLoader() {
		if (this.props.isFetchingMapLayers) {
			return (
				<div style={{display: "flex"}}>
					<span style={{margin: "auto"}}>
						<i className="fas fa-circle-notch fa-spin fa-fw" />
						&nbsp;
						Carregando...
					</span>
				</div>
			);
		}
	}

	render () {
		const display = this.props.layers.length === 0 ? 'none' : 'block';
		return (
			<div className="container cmCamadas">
				<div className="">
					<b>Camadas</b>
				</div>
				<div className="row">
					<div className="col-md-6" style={{'display': display}} >
						<input 
							type="checkbox"
							style={{marginRight: "2px"}}
							checked={this.props.showLegend}
							onChange={(e) => this.props.setShowLegend(e.target.checked)} 
						/>
						Exibir Legendas
					</div>
					<div className="col-md-6" style={{'display': display}} >
						<input 
							type="checkbox" 
							style={{marginRight: "2px"}}
							onChange={() => this.props.resetLayers([])} 
							checked={this.props.layers.length === 0}
						/>
						Limpar Seleção
					</div>
				</div>
				<div style={{paddingTop: "0px", paddingBottom: "5px", marginBottom: "5px", borderBottom: "1px solid #eee"}}>
					{this.props.layers.map((l, i) =>
						<SelectedLayer 
							key={l.id}
							layers={this.props.layers}
							layer={l} 
							index={i} 
							moveLayer={this.props.moveLayer}
							removeLayer={this.props.removeLayer}
							zoomToLayer={this.props.zoomToLayer}
							getMapLayerCapabilities={this.props.getMapLayerCapabilities}
						/>
					)}
				</div>
				{this.maplayerLoader()}
				<MapLayers 
					maplayers={this.props.maplayers}
					visibleLayers={this.props.layers}
					getMapLayers={this.props.getMapLayers}
					changeOneMapLayer={this.props.changeOneMapLayer}
					addVisibleLayer={this.props.addLayer}
					removeVisibleLayer={this.props.removeLayer}
					projects={this.props.projects}
					isGisOnly={this.props.isGisOnly}
					isGisAdmin={this.props.isGisAdmin}
				/>

			</div>		
		);
	}

}

Layers.propTypes = {
	layers: PropTypes.array.isRequired,
	isFetchingMapLayers: PropTypes.bool.isRequired,
	maplayers: PropTypes.array.isRequired,
	getMapLayers: PropTypes.func.isRequired,
	changeOneMapLayer: PropTypes.func.isRequired,
	addLayer: PropTypes.func.isRequired,
	removeLayer: PropTypes.func.isRequired,
	moveLayer: PropTypes.func.isRequired,
	zoomToLayer: PropTypes.func.isRequired,
	getMapLayerCapabilities: PropTypes.func.isRequired,
	setShowLegend: PropTypes.func.isRequired,
	showLegend: PropTypes.bool.isRequired,
	resetLayers: PropTypes.func.isRequired,
	projects: PropTypes.object.isRequired,
	isGisOnly: PropTypes.bool.isRequired,
	isGisAdmin: PropTypes.bool.isRequired
};


// WEBPACK FOOTER //
// ./src/components/Explorer/Layers.js